import { PageBaseProps } from "../my-type";

export default function PageBase({ header, content }: PageBaseProps) {
  return <div className="fleet-page-base">
    {header && <div className="fleet-page-base-header">{header}</div>}
    {content}
  </div>;
}
